import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Stack, Typography, Button } from '@mui/material';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import AddIcon from '@mui/icons-material/Add';
import { TableV2, CustomFilterV2 } from '../../../components/v2';
import * as selectorsSubestacoes from '../../../store/subestacao/reducer';
import * as actionsSubestacoes from '../../../store/subestacao/actions';
import Formulario from './Formulario';

const Subestacoes = ({ subestacoes, loadSubestacoes, deleteSubestacao }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [openFilter, setOpenFilter] = useState(false);

  useEffect(() => {
    loadSubestacoes();
  }, [loadSubestacoes]);

  const columns = [
    { field: 'codigo', headerName: 'Código', flex: 0.4 },
    { field: 'nome', headerName: 'Nome', flex: 1 },
    {
      field: 'polosCodigos',
      headerName: 'Polos',
      flex: 0.8,
      renderCell: (params) => {
        const val = params.row.polosCodigos;
        return val && Array.isArray(val) ? val.join(', ') : '';
      },
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'flex-start', md: 'center' }}
          spacing={2}
        >
          <Typography variant="h4">Subestações</Typography>
          <Button
            variant="outlined"
            startIcon={<FilterListOutlinedIcon />}
            onClick={() => setOpenFilter(true)}
          >
            Filtros
          </Button>
        </Stack>

        <TableV2
          rows={subestacoes}
          columns={columns}
          onEdit={id => { setOpen(true); setId(id); }}
          onDelete={id => deleteSubestacao(id)}
          headerActions={[
            { label: 'Novo', onClick: () => { setOpen(true); setId(null); }, startIcon: <AddIcon />, variant: 'contained' },
          ]}
        />

        <CustomFilterV2
          variant="dialog"
          open={openFilter}
          onClose={() => setOpenFilter(false)}
          title="Filtros"
          fullWidth
          fields={[
            { field: 'useCodigo', md: 3 },
            { field: 'useMalha', md: 3 },
            { field: 'useGerencia', md: 3 },
            { field: 'usePolo', md: 3 },
          ]}
          onFilter={filterData => {
            loadSubestacoes(filterData);
            setOpenFilter(false);
          }}
        />

        <Formulario
          id={id}
          open={open}
          onClose={isSave => {
            setOpen(false);
            setId(null);
            if (isSave) loadSubestacoes();
          }}
          subestacoes={subestacoes}
        />
      </Stack>
    </Box>
  );
};

Subestacoes.propTypes = {
  deleteSubestacao: PropTypes.func.isRequired,
  loadSubestacoes: PropTypes.func.isRequired,
  subestacoes: PropTypes.array,
};

const mapStateToProps = state => ({
  subestacoes: selectorsSubestacoes.getSubestacoes(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsSubestacoes
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Subestacoes));
